import { useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

import { api } from '@services';

export const usePublicQuestionMutation = (roomId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (question: string) => {
      const { data } = await api.post(`/rooms/${roomId}/public-questions`, {
        room_id: roomId,
        question,
      });
      return data;
    },
    {
      onSuccess: (data) => {
        toast.success(data.message || 'Pergunta enviada com sucesso!');
        queryClient.invalidateQueries(['public-questions', roomId]);
      },
      onError: (err: AxiosError<{ message: string }>) => {
        const message =
          err.response?.data?.message ||
          'Erro ao enviar pergunta. Tente novamente.';
        toast.error(message);
      },
    },
  );
};
